import { green as greenMuiColor } from '@mui/material/colors';

const green = {
  ...greenMuiColor,
  C757: '#32d583',
};

export default green;
